<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelService()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-label>Service Job Details</ion-label>
    </ion-toolbar>
</ion-header>

<ion-content>
    <select-plant *ngIf="!documentTemp.serviceJob.$loki" [document]="documentTemp"></select-plant>
    <job-details *ngIf="document.serviceJob.jobNumber !== 0" [document]="documentTemp"></job-details>
    <manual-ref [serviceJob]= "documentTemp.serviceJob"></manual-ref>
    <customer *ngIf="!documentTemp.serviceJob.$loki && documentTemp.customer" [document]="documentTemp"
             (customerChange)="listenCustomer($event)"></customer>
    <site [document]="documentTemp"></site>
    <details-existing-job *ngIf="document.serviceJob.jobNumber === 0" [document]="documentTemp"></details-existing-job>
    <time-clocking *ngIf="config.showJobHoursComponent" [document]="documentTemp"></time-clocking>
    <tasks-list [document]="documentTemp"></tasks-list>
    <customer-details *ngIf="documentTemp.documentNumber !== 0 && documentTemp.customer"
        [document]="documentTemp"></customer-details>
    <spares-fuel-ws [document]="documentTemp" [title]="'Parts'"></spares-fuel-ws>
    <spares-fuel-ws [document]="documentTemp" [title]="'Fuel'"></spares-fuel-ws>
    <meters-readings-taken [document]="documentTemp"></meters-readings-taken>
    <picturestaken [document]="documentTemp"></picturestaken>
    <simple-signature  *ngIf="config.showCustomerSigComponent" [document]="documentTemp" [title]="'Signature'"></simple-signature>
    <simple-signature [document]="documentTemp" [title]="'Engineer Signature'"></simple-signature>
    <comments *ngIf="!mobileConfiguration.mobilehireHideServiceJobCommentsField" [document]="documentTemp" class="ion-margin-bottom"></comments>
    <job-certificate [document]="documentTemp"></job-certificate>
    <bin-location [document]="documentTemp"></bin-location>
    
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="saveServiceJob()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
